import { styled } from "@mui/material";

import { RoutedTabContent } from "fond/widgets/RoutedTabs.styles";

export const SettingsTabContent = styled(RoutedTabContent)`
  padding-inline: ${({ theme }) => theme.spacing(6)};
`;

export const UserManagementTabContent = styled(SettingsTabContent)`
  padding-top: ${({ theme }) => theme.spacing(2.25)};
`;
